import Media from './media';
import Property from './property';

class Client {
  id: number;
  name: string;
  created_at: Date;
  updated_at: Date;
  properties: Property[];
  slug: string;
  description: string;
  media_demo: Media[];
  media_profile: Media;
  first_name: string;
  last_name: string;
  video_demo: Media;

  fromJson(data): Client {
    this.id = data.id;
    this.name = data.name;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    if (data.properties) {
      this.properties = data.properties.map((p) => new Property().fromJson(p));
    }
    this.slug = data.slug;
    this.description = data.description;
    if (data.media_demo) {
      this.media_demo = data.media_demo
        .map((m) => new Media().fromJson(m))
        .sort((a, b) => {
          const aDate = new Date(a.created_at);
          const bDate = new Date(b.created_at);
          return bDate.getTime() - aDate.getTime();
        });
    }
    if (data.media_profile) {
      this.media_profile = new Media().fromJson(data.media_profile);
    }
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    if (data.video_demo) {
      this.video_demo = new Media().fromJson(data.video_demo);
    }
    return this;
  }
}

export default Client;
